/**
 * Если часть DOM-элемента находится в области видимости, возвращает true. Иначе - false
 * @param el - DOM-element
 * @param viewPercent - число от 0 до 1, процент требуемой видимости блока
 */
export var isElementInViewport = function isElementInViewport(el) {
  var viewPercent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var rect = el.getBoundingClientRect();
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowWidth = window.innerWidth || document.documentElement.clientWidth;
  var vertBottomInView = rect.top - rect.height * viewPercent + rect.height >= 0;
  var vertTopInView = rect.top + rect.height * viewPercent <= windowHeight;
  var horLeftInView = rect.left + rect.width * viewPercent <= windowWidth;
  var horRightInView = rect.left - rect.width * viewPercent + rect.width >= 0;
  return vertBottomInView && horRightInView && vertTopInView && horLeftInView;
};